import React, {Component} from "react"
import PropTypes from "prop-types"
import {Badge, Button, ButtonToolbar, Glyphicon, Panel} from "react-bootstrap"
import {Date, Enums, Grid} from "../../utils";
import {AllergyStatus, AllergyStatusLabel, AnimalKind, AnimalKindLabel, CastrationStatus, CastrationStatusLabel, DOG_MIX_BREED_ID, SizeType, WeightUnitLabel} from "../../utils/enums";
import {Link} from "react-router-dom";
import {getLink} from "../../utils/files";
import {formatQuaran} from "../../utils/format";

class DogDetail extends Component {

	getStatusTitle(value) {
		switch (value) {
			case "ACTIVE":
				return <span><Glyphicon glyph="ok"/> Aktivní</span>;
			case "DELETED":
				return <span><Glyphicon glyph="remove"/> Neaktivní</span>;
			default:
				return value
		}
	}

	renderBaseInfo(item) {
		const {files, intakes, enums} = this.props;

		const visualDescItems = [];
		const behaviorDescItems = [];
		const allergyDescItems = [];
		if (intakes && intakes.length) {
			intakes.forEach((intake) => {
				if (intake.visualDesc && intake.visualDesc !== item.visualDesc) {
					visualDescItems.push(intake);
				}
				if (intake.behaviorDesc && intake.behaviorDesc !== item.behaviorDesc) {
					behaviorDescItems.push(intake);
				}
				if (intake.allergyDesc && intake.allergyDesc !== item.allergyDesc) {
					allergyDescItems.push(intake);
				}
			})
		}

		return <Panel>
			<Panel.Heading>
				<span>Evidenční karta <Badge className="pull-right">{item.dogId}</Badge></span>
			</Panel.Heading>
			<Panel.Body>
				<table className="table table-detail">
					<colgroup>
						<col width="17%"/>
						<col width="15%"/>
						<col width="15%"/>
						<col width="12%"/>
						<col width="15%"/>
						<col width="27%"/>
					</colgroup>
					<tbody>
					<tr>
						<th>Jméno</th>
						<td colSpan={3}>{item.name + (item.altNames ? ' (' + item.altNames + ')' : '')}</td>
						<th>Ev. č.</th>
						<td rowSpan={2} style={{whiteSpace: "nowrap"}}>{(item.dogNumber || '') + (item.altDogNumbers ? ' (' + item.altDogNumbers + ')' : '')}</td>
					</tr>
					<tr>
						<th>Druh</th>
						<td>{item.animalKind && AnimalKindLabel[item.animalKind]}</td>
						<th>Velikost</th>
						<td>{item.size && SizeType[item.size]}</td>
					</tr>
					<tr>
						<th>Plemeno</th>
						<td colSpan={5}>
							{item.breedId && Enums.getEnumTitle(enums, 'breed', item.breedId)}
							{item.breedDetail && (item.breedId === DOG_MIX_BREED_ID
								? <span> ({item.breedDetail.split(',').map((v) => Enums.getEnumTitle(enums, 'breed', v)).join(', ')})</span>
								: (item.animalKind === AnimalKind.OTHER ? <span> ({item.breedDetail})</span> : null))}
							{item.breedId && item.breedId !== DOG_MIX_BREED_ID && (
								item.isPaper ? ' (s PP)' : ' (bez PP)'
							)}
						</td>
					</tr>
					<tr>
						<th>Pohlaví</th>
						<td>{item.sex}</td>
						<th>Narození</th>
						<td>{Date.formatDateOrYear(item.birthDate)}</td>
						<th>Pas</th>
						<td>{item.passNumber}</td>
					</tr>
					<tr>
						<th>Tetování</th>
						<td colSpan={3}>
							{item.isTat ? (item.tatNumber || 'Ano') : 'Ne'}
							{item.isTat && item.tatDesc && ' (' + item.tatDesc + ')'}
						</td>
						<th>Čip</th>
						<td rowSpan={2}>{item.chipNumber && item.chipNumber.split(',').map((v, i) => <kbd key={i}>{v}</kbd>)}</td>
					</tr>
					<tr>
						<th>Kastrace</th>
						<td colSpan={3}>
							{item.castrationStatus ? CastrationStatusLabel[item.castrationStatus] : CastrationStatusLabel[CastrationStatus.UNKNOWN]}
							{item.castrationStatus === CastrationStatus.YES && item.castrationDate && ' (' + Date.formatDate(item.castrationDate) + ')'}
						</td>
					</tr>
					<tr>
						<th>Vzhled</th>
						<td colSpan={5}>{item.visualDesc}</td>
					</tr>
					{visualDescItems.length > 0 && visualDescItems.map((intake, i) => {
						return <tr key={i} className={'sub-row'}>
							<td>{Date.formatDate(intake.intakeAt)}</td>
							<td colSpan={5}><i>{intake.visualDesc}</i></td>
						</tr>
					})}
					<tr>
						<th>Chování</th>
						<td colSpan={5}>{item.behaviorDesc}</td>
					</tr>
					{behaviorDescItems.length > 0 && behaviorDescItems.map((intake, i) => {
						return <tr key={i} className={'sub-row'}>
							<td>{Date.formatDate(intake.intakeAt)}</td>
							<td colSpan={5}><i>{intake.behaviorDesc}</i></td>
						</tr>
					})}

					<tr className="divider">
						<th>Karanténa</th>
						<td colSpan={3}>{formatQuaran(item)}</td>
						<th>Váha</th>
						<td rowSpan={2}>
							{item.weight && item.weight.weightItems && item.weight.weightItems.map((wi, i) => <div key={i}>
								{Date.format(wi.weightDate, "DD.MM.YY")}: {("" + wi.weightValue).replace('.', ',')}&nbsp;{WeightUnitLabel[wi.weightUnit]}
							</div>)}
						</td>
					</tr>
					<tr>
						<th>Alergie</th>
						<td colSpan={4}>
							{item.allergyStatus ?
								(item.allergyStatus === AllergyStatus.YES && item.allergyDesc ? item.allergyDesc : AllergyStatusLabel[item.allergyStatus])
								: AllergyStatusLabel[AllergyStatus.UNKNOWN]}
							{item.allergyStatus === AllergyStatus.YES && item.allergyInfo && <div>{item.allergyInfo}</div>}
						</td>
					</tr>
					{allergyDescItems.length > 0 && allergyDescItems.map((intake, i) => {
						return <tr key={i} className={'sub-row'}>
							<td>{Date.formatDate(intake.intakeAt)}</td>
							<td colSpan={5}><i>{intake.allergyDesc}</i></td>
						</tr>
					})}

					<tr className="divider">
						<th>Stav</th>
						<td colSpan={5}>{this.getStatusTitle(item.status)}</td>
					</tr>

					<tr className={'divider'}>
						<th>Přílohy</th>
						<td className={'table-item-files'} colSpan={5}>{files && files.length > 0 && files
							.filter(f => !f.examId && !f.intakeId && !f.eventId && !f.eventId && !f.exitId)
							.map((f) => {
								let fileName = f.fileName;
								if (fileName && fileName.length > 35) {
									fileName = fileName.substring(0, 17).trim() + '...' + fileName.substring(fileName.length - 18).trim();
								}
								return <a target={'_blank'} key={f.fileId} href={getLink(f.guid, f.fileName)}>{fileName}</a>;
							})}</td>
					</tr>
					</tbody>
				</table>
				<ButtonToolbar className={"text-center"}>
					<Button type="button" className="btn btn-sm btn-default" onClick={() => this.props.onPrintOpen('ZK')}><Glyphicon glyph="print"/> Tisk ZK</Button>
					<Link to={{pathname: "/psi/" + item.dogId + "/uprava"}} className="btn btn-sm btn-default"><Glyphicon glyph="pencil"/> Upravit</Link>
				</ButtonToolbar>
			</Panel.Body>
		</Panel>;
	}

	render() {
		const {isFetchingItem, item} = this.props;
		if ((isFetchingItem && item === null) || item === null) {
			return Grid.renderIsFetchingData()
		}

		return this.renderBaseInfo(item)
	}
}

DogDetail.propTypes = {
	item: PropTypes.object,
	isFetchingItem: PropTypes.bool.isRequired,
	onPrintOpen: PropTypes.func.isRequired,
	files: PropTypes.array,
	intakes: PropTypes.array,
	session: PropTypes.object.isRequired
};

export default DogDetail



// WEBPACK FOOTER //
// ./src/components/dog/DogDetail.js